import { render, staticRenderFns } from "./shopTag.vue?vue&type=template&id=2bf5ec61&"
import script from "./shopTag.vue?vue&type=script&lang=js&"
export * from "./shopTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports